module.exports = __webpack_public_path__ + "img/man--1320.e99bdd5.jpg";